import { GridColDef } from "@mui/x-data-grid";
import { Property } from "@stratify/shared";
import { Timestamp } from "firebase/firestore";
import { useSelector } from "react-redux";
import { selectDocumentCountsByPropertyId } from "../store/propertiesSelectors";

export const usePropertyListColumns = (): GridColDef<Property>[] => {
  const documentCounts = useSelector(selectDocumentCountsByPropertyId);
  const column: GridColDef<Property>[] = [
    {
      field: "address",
      headerName: "Property Address",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "neighbourhood",
      headerName: "Neighbourhood",
      flex: 0,
      minWidth: 130,
      valueFormatter: (value: string) => value || "-",
    },
    {
      field: "suburb",
      headerName: "Suburb",
      flex: 0,
      minWidth: 120,
      valueFormatter: (value: string) => value || "-",
    },
    {
      field: "city",
      headerName: "City",
      flex: 0,
      minWidth: 110,
      valueFormatter: (value: string) => value || "-",
    },
    {
      field: "strataPlanNumber",
      headerName: "Strata Plan Number",
      flex: 0,
      minWidth: 150,
      valueFormatter: (value: string) => value || "-",
    },
    {
      field: "documentCount",
      headerName: "# Documents",
      type: "number",
      align: "right",
      headerAlign: "center",
      width: 120,
      valueGetter: (_, row) => documentCounts[row?.id] || 0,
    },
    {
      field: "createdAt",
      headerName: "Date Added",
      minWidth: 150,
      valueFormatter: (timestamp: Timestamp) =>
        timestamp.toDate().toLocaleDateString("en-CA", {
          year: "numeric",
          month: "short",
          day: "numeric",
        }),
    },
  ];
  return column;
};
